import React, {useState, useEffect, useRef, Fragment} from 'react';
import * as S from './RightBlock.styles';

import ProfileInfo from './ProfileInfo/ProfileInfo';
import CompanyInfo from './CompanyInfo/CompanyInfo';
import SupportInfo from './SupportInfo/SupportInfo';
import ManageGst from './ManageGst/ManageGst';
import ManageGstResp from './ManageGst/ManageGstResp/ManageGstResp';
import TextNButtonPersuasion from './ManageGst/Coachmark/TextNButtonPersuasion';

const RightBlock = ({
  userInfo,
  supportInfo,
  handleAgreementClick,
  ccdeCookie,
  fetchData,
  sendTrackingDataToSdk,
}) => {
  const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);
    React.useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleWindowResize);
      return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return {width};
  };

  const CoachMarkRef = useRef<any>();
  const [coachmark, setCoachmark] = useState(false);
  // const [backdrop, setBackdrop] = useState(true);
  // const [cardPos, setCardPos] = useState({top: 0, left: 0, width: 0});
  // const [isData, setIsData] = useState(false);

  // useEffect(() => {
  //   if (userInfo?.traveller_gst_info?.gstDetails?.length === 0) {
  //     setIsData(true);
  //   }
  // }, [userInfo?.traveller_gst_info?.gstDetails]);

  // useEffect(() => {
  //   if (isData && CoachMarkRef?.current) {
  //     window.requestAnimationFrame(() => {
  //       // Scroll to the element
  //       window.scrollTo({
  //         top: CoachMarkRef.current.offsetTop - 200, // Adjust the scroll position
  //         behavior: 'smooth',
  //       });

  //       // Disable scrolling on the page
  //       //

  //       // Set timeout to update card position and show coachmark
  //       const timeoutId = setTimeout(() => {
  //         setCardPos({
  //           top: CoachMarkRef.current.offsetTop - window.scrollY + 80,
  //           left: CoachMarkRef.current.offsetLeft,
  //           width: CoachMarkRef.current.offsetWidth,
  //         });
  //         setCoachmark(true); // Show the coachmark
  //         setBackdrop(false); // Hide the backdrop after the scroll
  //         document.querySelector('html').classList.add('noScroll');
  //       }, 900);

  //       // Cleanup function
  //       return () => {
  //         clearTimeout(timeoutId);
  //         document.querySelector('html').classList.remove('noScroll');
  //       };
  //     });
  //   }
  // }, [CoachMarkRef, isData]);

  const {width} = useViewport();
  const breakpoint = 766;
  return (
    <>
      <S.RightBlockMainWrap>
        <S.RightInnerWrap>
          <ProfileInfo
            userData={userInfo}
            handleAgreementClick={handleAgreementClick}
            fetchData={fetchData}
            sendTrackingDataToSdk={sendTrackingDataToSdk}
          />
          <CompanyInfo userData={userInfo} sendTrackingDataToSdk={sendTrackingDataToSdk} />
          {width <= breakpoint ? (
            <ManageGstResp userData={userInfo} />
          ) : (
            <ManageGst userData={userInfo} ref={CoachMarkRef} />
          )}
          {ccdeCookie == 'IN' && supportInfo && Object.keys(supportInfo).length !== 0 ? (
            <SupportInfo supportInfo={supportInfo} />
          ) : null}
        </S.RightInnerWrap>
      </S.RightBlockMainWrap>
      {/* {width > breakpoint && coachmark ? (
        <Fragment>
          <TextNButtonPersuasion
            compStyle={{
              top: cardPos.top,
              left: cardPos.left,
              width: cardPos.width,
            }}
            variant="COACH_MARK"
            customClass={'appendBottom20'}
            coachMarkData={{
              label: 'Select From Saved GST Details',
              subLabel: 'Add GST details for easy selection on hotels and flights booking',
              btnLabel: 'OK, GOT IT',
            }}
            component={<ManageGst userData={userInfo}></ManageGst>}
            coachMarkBtnClicker={() => {
              setCoachmark(false);
              document.querySelector('html').classList.remove('noScroll');
            }}
          />
        </Fragment>
      ) : null} */}
      {/* {userInfo?.traveller_gst_info?.gstDetails?.length === 0 &&
        width > breakpoint &&
        (backdrop || coachmark) && (
          <S.RightBackdrop
            onClick={() => {
              setCoachmark(false);
              document.querySelector('html').classList.remove('noScroll');
            }}
          />
        )} */}
    </>
  );
};

export default RightBlock;
